import { Avatar, Tooltip, Typography } from '@mui/material';
import React, { CSSProperties, useEffect, useState } from 'react';

import AssetService from '../../shared/services/AssetService';
import Grid from '@mui/material/Unstable_Grid2';
import LessonDisplaySettings from '../models/LessonDisplaySettings';
import LessonService from '../../dashboard/services/LessonService';
import { styled } from '@mui/system';
import styles from '../styles/LessonPlayer.scss';

interface ILessonTitleInfo {
  displaySettings: LessonDisplaySettings;
  lessonTitle: string;
  timeToComplete?: number; // Module completion time.
}

const StyledAvatar = styled(Avatar)(({ theme }) => ({
  width: theme.spacing(8),
  height: theme.spacing(8),
  fontSize: '24px',
  backgroundColor: theme.palette.grey[500]
}));

export const LessonTitleInfo = (props: ILessonTitleInfo) => {
  const [avatarStyle, setAvatarStyle] = useState<CSSProperties>();
  const [avatarImage, setAvatarImage] = useState('');

  useEffect(() => {
    const displaySettings = props.displaySettings;
    if (displaySettings?.icon?.type === 'color') {
      setAvatarStyle({
        backgroundColor: displaySettings.icon.value || undefined
      });
      setAvatarImage('');
    }

    if (displaySettings?.icon?.type === 'image') {
      setAvatarImage(AssetService.getAssetUrl(displaySettings.icon.value));
      setAvatarStyle(undefined);
    }
  }, [props.displaySettings]);

  return (
    <>
      <Grid>
        <StyledAvatar style={avatarStyle} src={avatarImage}>
          {props.lessonTitle?.toUpperCase()[0]}
        </StyledAvatar>
      </Grid>

      <Grid container direction="column" className={styles.title}>
        <Grid>
          <Typography variant="caption" textTransform={'uppercase'}>
            Lesson
            {props.timeToComplete
              ? LessonService.getModuleEstimationTime(props.timeToComplete)
              : ''}
          </Typography>
        </Grid>
        <Grid>
          <Tooltip title={props.lessonTitle} placement="bottom-start">
            <Typography variant="h6" className={styles.lessonTitle}>
              {props.lessonTitle}
            </Typography>
          </Tooltip>
        </Grid>
      </Grid>
    </>
  );
};
